import { ProjectMember } from "domain/entities/project-member";
import { Column } from "primereact/column";
import { DataTable, DataTableFilterEvent } from "primereact/datatable";
import { useEffect, useState } from "react";
import { ProjectMemberInputFilter } from "domain/models/project-member-input-filter";
import { useProjectMembersByFilter } from "presentation/hooks/use-query-project-member";
import { useProjectMemberUploadStore } from "presentation/stores/use-project-member-upload-store";
import { useProjectStore } from "presentation/stores/use-project-store";
import { Dialog } from "primereact/dialog";
import TeamInfoForm from "./TeamInfoForm";
import { useCurrentProjectMemberStore } from "presentation/stores/use-current-project-member-store";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import HeaderTeamInfoGrid from "./HeaderTeamInfoGrid";
import { useFilterProjectMemberProjectStore } from "presentation/stores/use-filter-project-member-project-store";
import { formatDateToPT } from "presentation/utils/formatDateToPT";

const TeamInfoGrid = () => {

  const formatDate = (date: Date | undefined) => {
    if (date) {
      const newDate = new Date(date);
      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const day = String(newDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
  };

  const confirmAction = (message: string, acceptCallback: () => void) => {
      confirmDialog({
        message: message,
        header: "Confirmação",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: acceptCallback,
      });
    };
  
  const { projectMembersUpload, setProjectMembersUpload } = useProjectMemberUploadStore();
  const { currentProjectMember, setCurrentProjectMember } = useCurrentProjectMemberStore();
  const { project, setProject, resetProject } = useProjectStore();
  const { filters, setFilters } = useFilterProjectMemberProjectStore();

  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => { setShowModal(true); };

  const handleCloseModal = async () => {
    setCurrentProjectMember(undefined);
    setShowModal(false);
  };

  
  const [lazyParams, setLazyParams] = useState({
    sortBy: "endAt",
    sortOrder: "desc",
    limit: 1000,
    page: 1,
    filters: {
      projectId: project?.id || "",
    },
  });
  const {
    data: projectMembers,
    isLoading,
    isError,
    error,
    refetch,
  } = useProjectMembersByFilter({
    sortBy: lazyParams.sortBy,
    sortOrder: lazyParams.sortOrder,
    page: lazyParams.page,
    limit: lazyParams.limit,
    ...lazyParams.filters,
  } as ProjectMemberInputFilter);

  // para nao transportar os projectMembers de um project para outro
  useEffect(() => {
    setLazyParams((prevParams) => ({
      ...prevParams,
      filters: {
        ...prevParams.filters,
        projectId: project?.id || "",
      },
    }));
    refetch();
  }, [project]);

  useEffect(() => {
    setProjectMembersUpload(projectMembers?.data || []);
  }, [projectMembers]);

  const updateProjectMember = (projMember: ProjectMember) => {
    setCurrentProjectMember(projMember);
    setShowModal(true);
  };

  const showActionOptions = (projMember: ProjectMember) => {
    return (
      <div className="spacing-icons">
        {!projMember.id?.includes("Temp") && (
          <i
            className="pi pi-pencil cursor-pointer"
            onClick={() => updateProjectMember(projMember)}
          />
        )}
        {projMember.status !== "Inativo" &&
          <i
            className="pi pi-times cursor-pointer"
            onClick={() => {
              confirmAction(`Deseja inativar ${projMember.employee?.name} neste projeto?`, () => {
                  const updatedList = projectMembersUpload.map(
                    (item) => {
                      if (item.id === projMember.id){
                        const endDate = item.endAt = new Date();
                        endDate.setDate(endDate.getDate() - 1)
                        item.status = "Inativo";
                      }
                      return item;
                    }
                  );
                  setProjectMembersUpload(updatedList);
                });
            }}
          />
        }
      </div>
    );
  };

  return (
    <div className="default-grid ">     

      <Dialog
        header="Adicionar colaborador"
        visible={showModal}
        style={{ width: "80vw" }}
        onHide={handleCloseModal}
      >
        <TeamInfoForm
          isDisable={false}
          onClose={handleCloseModal}
        />
      </Dialog> 

      <div className="default-4-cols">
        <DataTable
          header={<HeaderTeamInfoGrid />}
          value={projectMembersUpload || []}
          tableStyle={{ minWidth: "50rem" }}
          onFilter={(e: DataTableFilterEvent) => setFilters(e.filters)}
          filters={filters}
          size="small"
          sortField={"status"}
          sortOrder={1}
        >
          <Column field="employee.name" header="Colaborador" sortable filter showFilterMatchModes={false}></Column>
          <Column field="projectRole" header="Função" sortable filter showFilterMatchModes={false}></Column>
          <Column field="startAt" header="Data de início" sortable body={(rowData) => formatDateToPT(rowData.startAt)}></Column>
          <Column field="endAt" header="Data de término" sortable body={(rowData) => formatDateToPT(rowData.endAt)}></Column>
          <Column field="status" sortable header="Status" filter showFilterMatchModes={false}></Column>
          <Column
            body={showActionOptions}
            header="Ações"
            align="center"
            alignHeader="center"
          />
        </DataTable>
      </div>

      <ConfirmDialog />
    </div>
  );
};

export default TeamInfoGrid;
